import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, makeObservable, runInAction } from "mobx";
import { CompositeBarItemController } from "../CompositeBar/CompositeBarItemController";
export default class MapNavigationItemController extends CompositeBarItemController {
  constructor() {
    super();
    makeObservable(this);
  }

  /**
   * Set this item to active state. If used it's recommended to override this method and a proper logic
   * for activating this item, so it's easier to programmatically control the item from other places.
   */
  activate() {
    runInAction(() => {
      this._active = true;
    });
  }

  /**
   * Set this item to inactive state. If used it's recommended to override this method and a proper logic
   * for deactivating this item, so it's easier to programmatically control the item from other places.
   */
  deactivate() {
    runInAction(() => {
      this._active = false;
    });
  }
  get width() {
    if (this.itemRef && this.itemRef.current && this.itemRef.current.offsetWidth > 0) {
      return this.itemRef.current.offsetWidth;
    }
    return undefined;
  }
  get height() {
    if (this.itemRef && this.itemRef.current && this.itemRef.current.offsetHeight > 0) {
      return this.itemRef.current.offsetHeight;
    }
    return undefined;
  }
  handleClick() {
    if (this.active) {
      this.deactivate();
    } else {
      this.activate();
    }
  }
}
// Basically used with custom renderer element, just to control basic properties of elements
export let GenericMapNavigationItemController = (_dec = action.bound, _dec2 = action.bound, _class = class GenericMapNavigationItemController extends MapNavigationItemController {
  constructor(options) {
    super();
    this.options = options;
    makeObservable(this);
  }
  get glyph() {
    return this.options.icon;
  }
  get viewerMode() {
    var _this$options;
    return (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.viewerMode;
  }
  activate() {
    var _this$options2;
    if ((_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.activate) {
      this.options.activate();
    }
    super.activate();
  }
  deactivate() {
    var _this$options3;
    if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.deactivate) {
      this.options.deactivate();
    }
    super.deactivate();
  }
  handleClick() {
    var _this$options4;
    if ((_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.handleClick) {
      this.options.handleClick();
    } else {
      super.handleClick();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "activate", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deactivate", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "deactivate"), _class.prototype), _class);